import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { ClinicUserListScene } from 'scenes';
import {Auth} from 'services';

class ClinicUserListContainer extends AbstractContainer {

  getTasks() {

    let clinic = Auth.getManagedClinic();

    return [
      {
        key: 'users',
        exec: (done, failure) => {
          API.get(`clinics/${clinic.id}/veterinarians`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <ClinicUserListScene users={results.users} />
  }
}

export default ClinicUserListContainer;
